import KeenSlider from 'keen-slider';

export default function () {
  if ($('#image-slider')[0]) {
    new KeenSlider(
      '#image-slider',
      {
        rubberband: false,
        loop: true,
      },
      [navigation]
    );
  }
}

function navigation(slider) {
  const arrowLeft = $('.arrow--left');
  const arrowRight = $('.arrow--right');
  const slides = $('.lazy-img');

  function listenArrows() {
    arrowLeft.on('click', slider.prev);
    arrowRight.on('click', slider.next);
  }

  function lazyLoad(el) {
    $(el).attr('src', $(el).data('src'));
    $(el).addClass('lazy-img--loaded');
  }

  slider.on('created', () => {
    listenArrows();
  });

  slider.on('animationEnded', () => {
    const rel = slider.track.details.rel;
    if ($(slides[rel + 1]).attr('src') === '') lazyLoad(slides[rel + 1]);
    if ($(slides[rel]).attr('src') === '') lazyLoad(slides[rel]);
  });
}
